import React, { useState } from 'react';
import Error from '../../Error/error';
import { Link } from 'gatsby';
import { Formik } from 'formik';
import * as Yup from 'yup';
import CustomInputField from '../../CustomInput/CustomInputField';
import UploadImgComponent from '../CommonComponent/UploadImgComponent';
import CommonInput from '../CommonComponent/CommonInput';
import CommonDatePicker, {
  currentYear,
  currentMonth
} from '../../../components/Dashboard-res/CommonComponent/CommonDatePicker';
import get from 'lodash/get';

const DrivingLicenseDetails = props => {
  const { setstepsInfo, data, setData } = props;
  const {
    handleChange,
    handleBlur,
    setFieldError,
    setFieldValue,
    setFieldTouched,
    touched,
    errors
  } = props.formik;
  function onChange(imgUrl, files, index) {
    data.drivingLicense.files = files;
    data.drivingLicense.imgUrl[index] = imgUrl;

    // data.drivingLicense.files[0] = file
    setData({
      ...data,
      drivingLicense: {
        ...data.drivingLicense,
        imgUrl: data.drivingLicense.imgUrl,
        files: data.drivingLicense.files
      }
    });
  }
  const { imgUrl } = data.drivingLicense;
  const frontImg = imgUrl[0];
  const backImg = imgUrl[1];

  return (
    <>
      <form className="w-full">
        <div className="flex flex-col justify-between ">
          <div className=" flex-1 flex flex-row justify-around w-full  ">
            <div className="w-1/2 py-12 ">
              <div className="my-7">
                <CommonInput
                  name="drivingLicense.fullName"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={data.drivingLicense.fullName}
                  stylesContainer={{
                    height: '52px',
                    maxWidth: '100%'
                  }}
                  legendName="Full Name"
                  error={
                    (touched.drivingLicense?.fullName || '') &&
                    (errors.drivingLicense?.fullName || '')
                  }
                  errorMsg={errors.drivingLicense?.fullName || ''}
                  touched={touched.drivingLicense?.fullName || ''}
                />
              </div>
              <div className="my-7">
                <CommonInput
                  name="drivingLicense.fatherName"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={data.drivingLicense.fatherName}
                  stylesContainer={{
                    height: '52px',
                    maxWidth: '100%'
                  }}
                  legendName="Father’s Name"
                  error={
                    (touched.drivingLicense?.fatherName || '') &&
                    (errors.drivingLicense?.fatherName || '')
                  }
                  errorMsg={errors.drivingLicense?.fatherName || ''}
                  touched={touched.drivingLicense?.fatherName || ''}
                />
              </div>
              <div className="my-7">
                <CommonInput
                  name="drivingLicense.drivingLicenseNo"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={data.drivingLicense.drivingLicenseNo}
                  stylesContainer={{
                    height: '52px',
                    maxWidth: '100%'
                  }}
                  legendName="DrivingLicense No"
                  error={
                    (touched.drivingLicense?.drivingLicenseNo || '') &&
                    (errors.drivingLicense?.drivingLicenseNo || '')
                  }
                  errorMsg={errors.drivingLicense?.drivingLicenseNo || ''}
                  touched={touched.drivingLicense?.drivingLicenseNo || ''}
                />
              </div>

              <div className="w-full mt-10">
                <label
                  style={{
                    justifySelf: 'center'
                  }}
                  htmlFor="drivingLicense_DOB"
                  className="text-sm text-black-400 "
                >
                  Date of Birth
                </label>
                <CommonDatePicker
                  onChangeMonth={(value, isValidDate) => {
                    setFieldValue('drivingLicense.month', value, true);
                    setFieldTouched('drivingLicense.month', true, false);
                    if (!isValidDate) {
                      setFieldValue(
                        'drivingLicense.date',
                        {
                          value: '',
                          label: 'Date'
                        },
                        true
                      );
                    }
                  }}
                  onChangeYear={(value, isValidDate) => {
                    setFieldValue('drivingLicense.year', value, true);
                    setFieldTouched('drivingLicense.year', true, false);

                    if (!isValidDate) {
                      setFieldValue(
                        'drivingLicense.date',
                        {
                          value: '',
                          label: 'Date'
                        },
                        true
                      );
                    }
                  }}
                  onChangeDate={value => {
                    setFieldValue('drivingLicense.date', value, true);
                    setFieldTouched('drivingLicense.date', true, false);
                  }}
                  valueMonth={data.drivingLicense.month}
                  valueYear={data.drivingLicense.year}
                  valueDate={data.drivingLicense.date}
                  errorYear={
                    (touched.drivingLicense?.year || null) &&
                    get(errors, 'drivingLicense.year.value', false) &&
                    (touched.drivingLicense.year === undefined
                      ? get(errors, 'drivingLicense.year.value', true)
                      : null)
                  }
                  touchedYear={touched.drivingLicense?.year || false}
                  onBlurYear={() => {
                    setFieldTouched('drivingLicense.year', true, true);
                  }}
                  errorMonth={
                    touched.drivingLicense?.month &&
                    get(errors, 'drivingLicense.month.value', false)
                  }
                  touchedMonth={touched.drivingLicense?.month}
                  onBlurMonth={() => {
                    setFieldTouched('drivingLicense.month', true, true);
                  }}
                  errorDate={
                    touched.drivingLicense?.date &&
                    get(errors, 'drivingLicense.date.value', false)
                  }
                  touchedDate={touched.drivingLicense?.date}
                  onBlurDate={() => {
                    setFieldTouched('drivingLicense.date', true, true);
                  }}
                  errorMsg={
                    errors.drivingLicense?.date ||
                    '' ||
                    errors.drivingLicense?.month ||
                    '' ||
                    errors.drivingLicense?.year ||
                    ''
                      ? 'please choose valid dob'
                      : null
                  }
                  type="dob"
                />

                <div className="my-7">
                  <CommonInput
                    name="drivingLicense.address"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={data.drivingLicense.address}
                    stylesContainer={{
                      height: '52px',
                      maxWidth: '100%'
                    }}
                    legendName="Address"
                    error={
                      (touched.drivingLicense?.address || '') &&
                      (errors.drivingLicense?.address || '')
                    }
                    errorMsg={errors.drivingLicense?.address || ''}
                    touched={touched.drivingLicense?.address || ''}
                  />
                </div>
                <div className="my-7">
                  <CommonInput
                    name="drivingLicense.bloodGroup"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={data.drivingLicense.bloodGroup}
                    stylesContainer={{
                      height: '52px',
                      maxWidth: '100%'
                    }}
                    legendName="Blood Group"
                    error={
                      (touched.drivingLicense?.bloodGroup || '') &&
                      (errors.drivingLicense?.bloodGroup || '')
                    }
                    errorMsg={errors.drivingLicense?.bloodGroup || ''}
                    touched={touched.drivingLicense?.bloodGroup || ''}
                  />
                </div>
              </div>
            </div>

            <div className="flex-initial w-1/3 mt-7">
              <div className="flex-1 flex flex-col  py-12">
                <div className=" shadow-lg">
                  <img src={frontImg} alt="" className="block h-48 w-64" />
                  <UploadImgComponent
                    onChange={(imgUrl, files) => {
                      onChange(imgUrl, files, 0);
                    }}
                    isChildrenBased
                  >
                    <p
                      className="underline text-black-800 text-xs"
                      style={{ position: 'relative', top: '30px' }}
                    >
                      Re-upload
                    </p>
                  </UploadImgComponent>
                </div>
                <div
                  className="shadow-lg"
                  style={{
                    marginTop: '52px'
                  }}
                >
                  <img src={backImg} alt="" className="h-48 w-64" />
                  <UploadImgComponent
                    onChange={(imgUrl, files) => {
                      onChange(imgUrl, files, 1);
                    }}
                    isChildrenBased
                  >
                    <p
                      className="underline text-black-800 text-xs"
                      style={{ position: 'relative', top: '30px' }}
                    >
                      Re-upload
                    </p>
                  </UploadImgComponent>
                </div>
              </div>
            </div>
          </div>
          <div className="my-5 ">
            <button
              disabled={errors.drivingLicense}
              type="submit"
              className="submitButton w-48 "
            >
              Continue
            </button>
          </div>
        </div>
      </form>
      );
    </>
  );
};

export default DrivingLicenseDetails;
